import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom"
import { IDomaines, recupererLocalisation, User, UserModel } from "../interfaces/utilisateur.interface";
import userServices from "../services/utilisateur.service";
import { Backdrop, Button, Card, CardContent, Checkbox, CircularProgress, darken, Dialog, DialogContent, FormControl, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, TextField, Typography } from "@mui/material";
import { Localisation } from "../../Missions/interfaces/missions.interface";
import { ClearIcon } from "@mui/x-date-pickers";
import { BorderColor, Check } from "@mui/icons-material";
import { BASE_COLOR } from "../../../shared/constants/color.constant";
import { grey } from "@mui/material/colors";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { GOOGLE_MAP_API_KEY } from "../../../config/Config";
import { DisponibilityContainer, DisponibilityPeriodeContainer, modifDisponibilityPeriod } from "./disponibility";
import { MODIF_USER, modifUserLabel } from "../../../shared/constants/userModifEnums";
import domaineServices from "../../Domaine/services/domaine.service";
import { Domaine } from "../../Domaine/interfaces/domaine.interface";

const UtilisateurModifComponent: React.FC<any> = () => {
    const { typeUser, id } = useParams();
    
    const [user, setUser] = useState<User | null>(null);

    const [firstname, setFirstname] = useState<string>('')
    const [lastname, setLastname] = useState<string>('')
    const [email, setEmail] = useState<string>('')
    const [numero, setNumero] = useState<string>('')
    const [numeroAvecCode, setNumeroAvecCode] = useState<string>('')
    const [codePays, setCodePays] = useState<string>('')
    
    const [siretEntreprise, setSiretEntreprise] = useState<string>('')
    const [tva, setTva] = useState<string>('')
    const [needingTva, setNeedingTva] = useState<boolean>(false)
    const [codeApe, setCodeApe] = useState<string>('')

    const [loading, setLoading] = useState(false)

    const handleNavigateVersUsers = (typeUser: string | undefined) => {
        navigate(`/utilisateur/${typeUser}`)
    }

    // ---- Pour prestataire uniquement ----

    const [localisation, setLocalisation] = useState<Localisation | null>(null)
    const [disponibilities, setDisponibilities] = useState<any[] | null>(null)

    const [clickedDispoDay, setClickedDispoDay] = useState<string | null>(null)
    const [clickedDispoValue, setClickedDispoValue] = useState<string | null>(null)

    const handleVilleReferenceChangeAsync = async (value: any) => {
        try {
            console.log(`Ville value: ${JSON.stringify(value)}`)

            const placeId = value.value.place_id
            const newLocalisation = await recupererLocalisation(placeId, value.label)
            
            setLocalisation(newLocalisation)
            console.log(`New Localisation: ${JSON.stringify(newLocalisation)}`)
        } catch (error) {
            console.error(error)
        }
    }

    const handleChangeDayDisponibility = (disponibilities: any[], dayValue: string, newPeriode: string) => {
        console.log(`So new periode for ${clickedDispoValue} is ${newPeriode}`)

        modifDisponibilityPeriod(disponibilities, dayValue, newPeriode)

        setClickedDispoDay(null);
        setClickedDispoValue(null);
    }

    const handleModification = () => {
        setLoading(true)
        try {
            if (user) {
                console.log(`Before update user: ${JSON.stringify(user)}`)

                if (typeUser === MODIF_USER.PRESTATAIRE) {
                    const updatedPrestataire = {
                        ...user,
                        firstname,
                        lastname,
                        email,
                        numero,
                        localisation: localisation,
                        disponibilities: disponibilities,
                        idEntreprise: {
                            ...user.idEntreprise,
                            siretEntreprise,
                            tva,
                            needingTva,
                            codeApe    
                        }
                    }

                    console.log(`Updated prestataire: ${JSON.stringify(updatedPrestataire)}`)
                    userServices.updateUser(updatedPrestataire)
                } else if (typeUser === MODIF_USER.CREATEUR) {
                    const updatedCreateur = {
                        ...user,
                        firstname,
                        lastname,
                        email,
                        numero,
                        idEntreprise: {
                            ...user.idEntreprise,
                            citeEP,
                            domaineEntreprise,
                            siretEntreprise,
                            tva,
                            needingTva,
                            codeApe    
                        }
                    }

                    console.log(`Updated createur: ${JSON.stringify(updatedCreateur)}`)
                    userServices.updateUser(updatedCreateur);
                } else if (typeUser === MODIF_USER.CREATEUR_MULTI) {
                    const updatedCreateurMulti = {
                        ...user,
                        firstname,
                        lastname,
                        email,
                        numero,
                        idEntreprise: {
                            ...user.idEntreprise,
                            nomGerant: nomGerantEP,
                            citeEP,
                            domaineEntreprise,
                            siretEntreprise,
                            tva,
                            needingTva,
                            codeApe    
                        }
                    }
                    console.log(`Updated createur-multi-compte: ${JSON.stringify(updatedCreateurMulti)}`)
                    userServices.updateUser(updatedCreateurMulti)
                }
                
                console.log(`User modifié avec success`)
                
                setLoading(false)
                handleNavigateVersUsers(typeUser)
            }
        } catch (error) {
            console.error(`Erreur de modification: ${error}`);
        }
    }

    // -------------------------------------

    // ------ Pour createur uniquement -----

    const [citeEP, setCiteEP] = useState<string>('')
    const [choixDomainesEntreprise, setChoixDomainesEntreprise] = useState<Domaine[]>([])
    const [domaineEntreprise, setDomaineEntreprise] = useState<IDomaines | null>(null)
    const [nomEntreprise, setNomEntreprise] = useState<string>('')

    // --- Pour createur-multi ---
    const [nomGerantEP, setNomGerantEP] = useState<string>('')

    const handleVilleCreateurChangeAsync = async (value: any) => {
        try {
            console.log(`Ville value: ${JSON.stringify(value)}`)
            
            setCiteEP(value.label)
            console.log(`New Ville: ${JSON.stringify(value.label)}`)
        } catch (error) {
            console.error(error)
        }
    }

    // -------------------------------------
    

    const handleCheckNeedingTva = () => {
        setNeedingTva(!needingTva)
    }

    const handlePhoneChange = (value: string, data: any) => {
        const extractedCountryCode = data.dialCode; // Code pays extrait
        const extractedPhoneNumber = value.replace(extractedCountryCode, "").trim(); // Retirer le code pays
    
        setCodePays(extractedCountryCode);
        setNumero(extractedPhoneNumber);
        setNumeroAvecCode(value)
      };

    const navigate = useNavigate()

    useEffect(() => {
        setLoading(true)
        if (typeUser === MODIF_USER.CREATEUR) {
            const fetchDomaines = async () => {
                try {
                    const response = await domaineServices.get();
                    if (response.data) {
                        setChoixDomainesEntreprise(response.data.domaines)
                    }
                } catch (error) {
                    console.error('ERROR when fetching Domaines: ', error)
                }
            }

            fetchDomaines();
        } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setLoading(true)
        if (id) {
            userServices.getById(id)
                .then(res => {
                    const tempUser = res.data.data
                    setUser(tempUser)

                    console.log(`User to modif: ${JSON.stringify(tempUser)}`)
                    
                    if (tempUser) {
                        setFirstname(tempUser.firstname)
                        setLastname(tempUser.lastname)
                        setEmail(tempUser.email)
                        setNumero(tempUser.numero)
                        setNumeroAvecCode("+33"+tempUser.numero)
                        setLocalisation(tempUser.localisation[0])

                        setNomGerantEP(tempUser.idEntreprise.nomGerant)
                        setCiteEP(tempUser.idEntreprise.citeEP)
                        setSiretEntreprise(tempUser.idEntreprise.siretEntreprise)
                        setTva(tempUser.idEntreprise.tva)
                        setNeedingTva(tempUser.idEntreprise.isTva)
                        setCodeApe(tempUser.idEntreprise.codeApe)

                        setDisponibilities(tempUser.disponibility)

                        setDomaineEntreprise(tempUser.idEntreprise.domaineEntreprise)
                        setNomEntreprise(tempUser.idEntreprise.nomEntreprise)
                    }

                    console.log(`User disponibility: ${JSON.stringify(tempUser.dispo)}`)

                    setLoading(false)
                })
                .catch(console.log)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="flex flex-col">
                <>
                    <Grid container spacing={2} padding={3} paddingBottom={0} direction={'row'}>
                        <Grid item>
                            <Typography variant="h5" component="div" fontWeight={'bold'}>
                                Modification informations {modifUserLabel(typeUser)}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} padding={3} paddingBottom={0} direction={'row'}>    
                        <Grid item>
                            <TextField
                                label="Nom"
                                variant="outlined"
                                margin="normal"
                                value={firstname}
                                onChange={(event) => {
                                    setFirstname(event.target.value)
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField 
                                label="Prénom"
                                variant="outlined"
                                margin="normal"
                                value={lastname}
                                onChange={(event) => {
                                    setLastname(event.target.value)
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField 
                                label="Email"
                                variant="outlined"
                                margin="normal"
                                type="email"
                                value={email}
                                onChange={(event) => {
                                    setEmail(event.target.value)
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <div className="pt-4">
                                <PhoneInput
                                    value={numeroAvecCode}
                                    onChange={handlePhoneChange}
                                    enableSearch={true}
                                    inputStyle={{
                                        width: "91%", // Style du champ
                                        height: "55px",
                                        fontSize: "16px",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                    }}
                                    buttonStyle={{
                                        borderRadius: "4px 0 0 4px",
                                        background: "#f0f0f0", // Style du bouton indicatif
                                        border: "1px solid #ccc",
                                    }}
                                    dropdownStyle={{
                                        background: "#fff",
                                        zIndex: 1000
                                    }}
                                />
                            </div>
                        </Grid>
                    </Grid>
                    
                    {
                        (typeUser === MODIF_USER.PRESTATAIRE) && (
                            <>
                                <Grid container spacing={2} padding={3} paddingBottom={0} direction={'row'}>
                                    <Grid item>
                                        <Typography variant="h6" component="div" fontWeight={'bold'}>
                                            Informations sur la ville
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2} padding={3} paddingBottom={0} direction={'row'}>
                                    <Grid item>
                                        <div style={{ width: '310px' }}>
                                            <GooglePlacesAutocomplete
                                                apiKey={GOOGLE_MAP_API_KEY}
                                                selectProps={{
                                                    value: localisation ? {
                                                        label: localisation.address,
                                                        value: localisation.address
                                                    } : undefined,
                                                    placeholder: 'Votre ville de référence',
                                                    onChange: handleVilleReferenceChangeAsync,
                                                    styles: {
                                                        control: (base) => ({
                                                            ...base,
                                                            width: '100%',
                                                        })
                                                    }
                                                }}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2} padding={3} paddingBottom={0} direction={'row'}>
                                    <Grid item>
                                        <Typography variant="h6" component="div" fontWeight={'bold'}>
                                            Disponibilité
                                        </Typography>
                                    </Grid>
                                </Grid>

                                <Grid container spacing={2} padding={3} paddingBottom={0} direction={'row'}>
                                    {(clickedDispoDay != null && clickedDispoValue !== null) && (
                                        <Dialog
                                            open={clickedDispoValue !== null}
                                            onClose={() => {
                                                setClickedDispoDay(null);
                                                setClickedDispoValue(null);
                                            }}
                                            maxWidth="sm"  // Taille de la popup, peut être "xs", "sm", "md", "lg", "xl"
                                            fullWidth // Rendre la fenêtre modale responsive
                                            PaperProps={{
                                                sx: {
                                                    borderRadius: 2,
                                                }
                                            }}
                                        >
                                            <DialogContent
                                                sx={{
                                                    padding: 0,
                                                    maxHeight: '100vh',
                                                    overflowY: 'auto',
                                                }}
                                            >
                                                <DisponibilityPeriodeContainer
                                                    currentDayDisponibility={clickedDispoDay}
                                                    clickedDispoValue={clickedDispoValue}
                                                    onCloseContainer={() => {
                                                        setClickedDispoDay(null)
                                                        setClickedDispoValue(null)
                                                    }}
                                                    onChangeDisponibility={(newPeriode) => {
                                                        if (disponibilities !== null) {
                                                            handleChangeDayDisponibility(disponibilities, clickedDispoValue, newPeriode)
                                                        }
                                                    }}
                                                />
                                            </DialogContent>
                                        </Dialog>
                                    )}

                                    {
                                        (user !== null && disponibilities !== null) && (
                                            <DisponibilityContainer
                                                disponibilities={disponibilities}
                                                onClickCard={(day: string, value: string) => {
                                                    console.log(`Day clicked => ${day}, its value => ${value}`)
                                                    setClickedDispoDay(day)
                                                    setClickedDispoValue(value)
                                                }}
                                                clickedValue={clickedDispoValue || ''}
                                            />
                                        )
                                    }
                                </Grid>
                            </>
                        )
                    }

                    {
                        (typeUser === MODIF_USER.CREATEUR || typeUser === MODIF_USER.CREATEUR_MULTI) && (
                            <>
                                <Grid container spacing={2} padding={3} paddingBottom={0} direction={'row'}>
                                    <Grid item>
                                        <Typography variant="h6" component="div" fontWeight={'bold'}>
                                            Ville
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2} padding={3} paddingBottom={0} direction={'row'}>
                                    <Grid item>
                                        <div style={{ width: '310px' }}>
                                            <GooglePlacesAutocomplete
                                                apiKey={GOOGLE_MAP_API_KEY}
                                                selectProps={{
                                                    value: (citeEP.trim() !== '') ? {
                                                        value: citeEP,
                                                        label: citeEP
                                                    } : undefined,
                                                    placeholder: 'Ville',
                                                    onChange: handleVilleCreateurChangeAsync,
                                                    styles: {
                                                        control: (base) => ({
                                                            ...base,
                                                            width: '100%',
                                                        })
                                                    }
                                                }}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                            </>
                        )
                    }
                    

                    <Grid container spacing={2} padding={3} paddingBottom={0} direction={'row'}>
                        <Grid item>
                            <Typography variant="h6" component="div" fontWeight={'bold'}>
                                Informations de votre entreprise
                            </Typography>
                        </Grid>
                    </Grid>

                    {
                        (typeUser === MODIF_USER.CREATEUR) && (
                            <>
                                <Grid container spacing={2} padding={3} paddingBottom={0} direction={'row'}>
                                    <Grid item>
                                    <FormControl sx={{ width: 310 }}>
                                        <InputLabel id="demo-simple-select-helper-label">Domaines</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-helper-label"
                                            id="demo-simple-select-helper"
                                            value={domaineEntreprise?._id}
                                            label="Domaines"
                                            onChange={(event: SelectChangeEvent) => {
                                                const domaineId = event.target.value
                                                const selectedDomaine = choixDomainesEntreprise.find(d => d._id === domaineId)

                                                if (selectedDomaine) {
                                                    setDomaineEntreprise(selectedDomaine)
                                                }
                                            }}
                                        >
                                            {
                                                choixDomainesEntreprise.map((domaineEntreprise) => (
                                                    <MenuItem value={domaineEntreprise._id}>{domaineEntreprise.name}</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                    </Grid>
                                </Grid>
                            </>
                        )
                    }

                    <Grid container spacing={2} padding={3} paddingBottom={0} direction={'row'}>

                        {
                            (typeUser === MODIF_USER.CREATEUR_MULTI) && (
                                <Grid item>
                                    <TextField
                                        label="Gérant de l'entreprise"
                                        variant="outlined"
                                        margin="normal"
                                        value={nomGerantEP}
                                        onChange={(event) => {
                                            setNomGerantEP(event.target.value)
                                        }}
                                    >

                                    </TextField>
                                </Grid>
                            )
                        }

                        {
                            (typeUser === MODIF_USER.CREATEUR) && (
                                <Grid item>
                                    <TextField 
                                        label="Nom de l'entreprise"
                                        variant="outlined"
                                        margin="normal"
                                        value={nomEntreprise}
                                        onChange={(event) => {
                                            setNomEntreprise(event.target.value)
                                        }}
                                    />
                                </Grid>
                            )
                        }

                        <Grid item>
                            <TextField 
                                label="Siret de votre entreprise"
                                variant="outlined"
                                margin="normal"
                                value={siretEntreprise}
                                onChange={(event) => {
                                    setSiretEntreprise(event.target.value)
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField 
                                label="Tva"
                                variant="outlined"
                                margin="normal"
                                value={tva}
                                onChange={(event) => {
                                    setTva(event.target.value)
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField 
                                label="Code ape"
                                variant="outlined"
                                margin="normal"
                                value={codeApe}
                                onChange={(event) => {
                                    setCodeApe(event.target.value)
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <div className="pt-1" style={{ display: 'flex', alignItems: 'center' }}> {/* Centrage vertical */}
                                <Checkbox 
                                    checked={needingTva} 
                                    onChange={handleCheckNeedingTva} 
                                    name="Tva" 
                                />
                                <Typography variant="body1">Assujetie à la TVA</Typography>
                            </div>
                        </Grid>
                    </Grid>
                    <div className="flex justify-center flex-col align-center">
                        <div className="my-5 flex justify-center gap-2">
                            <Button
                                variant="contained"
                                color="error"
                                onClick={() => handleNavigateVersUsers(typeUser)}
                            >
                                Annuler
                            </Button>
                            <Button
                                variant="contained"
                                color="success"
                                onClick={handleModification}
                            >
                                Modifier
                            </Button>
                        </div>
                    </div>

                    <Backdrop open={loading} sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}>
                        <CircularProgress />
                    </Backdrop>
                </>
        </div>
    )
}

export default UtilisateurModifComponent